/**
 * Tiny FormSubmit.co AJAX helper.
 *
 * IMPORTANT: The FIRST POST to this endpoint will trigger a one-time
 * verification email from FormSubmit to team@powerbess.ai. The team
 * member must click the confirmation link in that email once to
 * activate the endpoint — after that, every form submission gets
 * forwarded silently.
 */

const FORMSUBMIT_ENDPOINT = "https://formsubmit.co/ajax/team@powerbess.ai";

export async function sendToTeam(payload) {
  const res = await fetch(FORMSUBMIT_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      _captcha: "false",       // we use a honeypot instead
      _template: "table",      // nicer formatted email
      _honey: "",              // honeypot — actual users leave empty
      ...payload,
    }),
  });

  // FormSubmit returns 200 with {success: "true"} on the happy path,
  // or 200 with {success: "false", message: "..."} on validation issues.
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* ignore parse errors — handled below */
  }

  if (!res.ok || String(data.success).toLowerCase() === "false") {
    const msg = data.message || `Submission failed (HTTP ${res.status})`;
    throw new Error(msg);
  }
  return data;
}
